export default "__VITE_ASSET__BuGu4kFt__"